module.exports = [{"type":"hash","text":"查詢係統時間"},{"type":"html","text":"<h4>HTTP請求</h4>"},{"type":"warning","text":"GET https://open-api.bingx.com/openApi/swap/v2/server/time"},{"type":"html","text":"<h4>參數： 無</h4>"},{"type":"html","text":"<li>code - int64 - 錯誤碼，0表示成功，不為0表示異常失敗</li>"},{"type":"html","text":"<li>msg - string - 錯誤信息提示</li>"},{"type":"html","text":"<li>serverTime - int64 - 係統當前時間，單位毫秒</li>"},{"type":"code","text":"{\"code\": 0,\"msg\": \"\",\"data\": {\"serverTime\": 1675319535362}}"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/api/basic/05_system_time.json
// module id = lC7j
// module chunks = 3